import { render } from "./WebsiteDetailV2.vue?vue&type=template&id=7802e2f2&scoped=true&ts=true"
import script from "./WebsiteDetailV2.vue?vue&type=script&lang=ts"
export * from "./WebsiteDetailV2.vue?vue&type=script&lang=ts"

import "./WebsiteDetailV2.vue?vue&type=style&index=0&id=7802e2f2&lang=scss&scoped=true"
import "./WebsiteDetailV2.vue?vue&type=style&index=1&id=7802e2f2&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7802e2f2"]])

export default __exports__